// extracted by mini-css-extract-plugin
export default {"logoWrapper":"TotalLogo_logoWrapper__AcXn3","totalLogo":"TotalLogo_totalLogo__zJQFe"};